// extracted by mini-css-extract-plugin
var _1 = "modal_btnPrimary__b9N3+";
var _2 = "modal_btnPrimaryOutline__0xPnZ";
var _3 = "modal_buttons__XUh5S";
var _4 = "modal_close__PDLph";
var _5 = "modal_container__YWMZ1";
var _6 = "modal_content__ARFeb";
var _7 = "modal_header__5GM86";
var _8 = "modal_isTransactionError__GTCx7";
var _9 = "modal_modal__RWQmB";
var _a = "modal_subtitle__KIDnX";
var _b = "modal_title__B+Ltu";
export { _1 as "btnPrimary", _2 as "btnPrimaryOutline", _3 as "buttons", _4 as "close", _5 as "container", _6 as "content", _7 as "header", _8 as "isTransactionError", _9 as "modal", _a as "subtitle", _b as "title" }
